import { render } from "./AssistantPortal.vue?vue&type=template&id=6ffd2a27&scoped=true"
import script from "./AssistantPortal.vue?vue&type=script&lang=js"
export * from "./AssistantPortal.vue?vue&type=script&lang=js"

import "./AssistantPortal.vue?vue&type=style&index=0&id=6ffd2a27&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffd2a27"]])

export default __exports__